import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBAutocomplete, MDBBtn, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import { set } from "react-hook-form";
export default memo(({ data, isConnectable }) => {
  const [isloading, setIsloading] = useState(true);
  function onDelete(id) {
    data.onDelete(id);
  }
  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );
  const [defaultData, setDefaultData] = useState([]);
  const [displayValuess, setDisplayValuess] = useState([]);

  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["users_and_extension"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log(tdata);
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const userList = tdata?.misc?.users_and_extensions?.users ?? [];
    const groupList = tdata?.misc?.users_and_extensions?.groups ?? [];

    const mergeWithSortList = [...userList, ...groupList];
    console.log(mergeWithSortList);
    setDefaultData(mergeWithSortList);
    setDisplayValuess(mergeWithSortList);
    setIsloading(false);
  }

  useEffect(() => {
    if(data && data.selected_object) {
      setSelected(data.selected_object ? data.selected_object.label : "");
    }
  }, [data]);

  useEffect(() => {
    fetchAAMiscData();
  }, []);

  const [customData, setCustomData] = useState(displayValuess);
  const onCustomSearch = (value) => {
    console.log(value);
    setCustomData(
      displayValuess.filter((item) =>
      (item.title.toLowerCase().includes(value.toLowerCase()) ||  item.extension.toString().includes(value.toLowerCase()))
      )
    );
  };
  let sharedWindow = null; // only one popup for all routes

 

  
  const handleFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(displayValuess);
    }
  };
  function getType(type,category) {
    let textVal = "";
    switch (type) {
      case 1:
        textVal = "";
        break;
      case 2:
        if(category){
          textVal = category ;
          break;
        }

    }
    return textVal;
  }
  return (
    <>
      <CFNodeUI
        headerClass="operatorNodeHeader"
        data={data}
        deletable={true}
        onDelete={onDelete}
        isConnectable={isConnectable}
        bodyContnent={
          <>
            <div>
              
              <MDBInput
                id="form1"
                type="text"
                size="sm"
                value={selected}
                disabled = {true}
                displayValue={(item) => {
                  const subpart = item && `${item.title} : ${item.is_primary == 1 ? 'Primary' : (item.type == 1 ? 'Exclude' : 'Include')} Directory`
                return `${subpart} `;
              }}
    
            />

            </div>
          </>
        }
        targetNode={true}
      />
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
